<template>
  <div class="cashflow-category-menu-items">
    <card-menu-item item-key="info"
                    v-if="showInfoPopups"
                    :onItemClick="emitOpenSectionInfoPopup"
                    :icon-src="require(`@/assets/${infoMenuItemIcon}`)"
                    :text="infoMenuItemText"/>
    <card-menu-item item-key="edit"
                    v-if="isEditable"
                    :onItemClick="emitEditRiseupGoalPopup"
                    :icon-src="require('@/assets/icons/gray-pencil.svg')"
                    text="עריכת סכום"/>
    <card-menu-item item-key="goToPlans"
                    v-if="planAheadBetaGroup"
                    :onItemClick="goToMyPlans"
                    icon-name="calendar_today"
                    text="לתוכניות שלי"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Segment from '@/Segment';
import BaseUI from 'base-ui';
import EventBus from '@/event-bus/event-bus';
import cashflowViewConsts from '@/constants/cashflow-view';
import RiseupGoalUpdatedToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/RiseupGoalUpdatedToaster';
import router from '@/router';
import RiseupGoalInfoPopup from '../../../../info-popups/RiseupGoalInfoPopup';
import EditRiseupGoalAmount from './EditRiseupGoalAmount.vue';
import InfoPopups from '../../../../info-popups/InfoPopups';

export default {
  name: 'RiseupGoalSectionMenu',
  components: {
    CardMenuItem: BaseUI.CardMenuItem,
  },
  mixins: [InfoPopups],
  props: {
    isEditable: {
      type: Boolean,
      required: true,
    },
    showInfoPopups: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('featureFlags', ['planAheadBetaGroup']),
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    emitOpenSectionInfoPopup() {
      this.trackInfoPopupClicked(cashflowViewConsts.cashflowTypes.riseupGoal);
      this.openModal({ component: RiseupGoalInfoPopup });
    },
    openToaster() {
      EventBus.$emit('open-toaster', {
        component: RiseupGoalUpdatedToaster,
        props: {},
      });
    },
    emitEditRiseupGoalPopup() {
      Segment.trackUserInteraction('SectionMenu_EditRiseupGoalClicked');
      this.openModal({
        component: EditRiseupGoalAmount,
        props: {
          onSaveCb: this.openToaster,
        },
      });
    },
    goToMyPlans() {
      Segment.trackUserInteraction('SectionMenu_GoToMyPlansClicked');
      router.push({ path: '/plan-ahead' });
    },
  },
};
</script>

<style>

</style>
